import {apiGet, apiPost, apiDelete, apiUpload} from './apiClient';

export async function fetchUserProfile() {
  return apiGet('/profile');
  // return {
  //   id: 'u_12345',
  //   name: 'Иван Петров',
  //   email: 'ivan.petrov@example.com',
  //   balance: 666,
  // };
}

export async function fetchUserPresentations() {
  return apiGet('/presentations');
  // return [
  //   { id: 'pres_001' },
  //   { id: 'pres_002' },
  //   { id: 'pres_003' }
  // ];
}

export async function fetchCommands() {
  return apiGet('/commands');
  // return [
  //   { id: 'cmd_1',  text: 'следующий слайд',  action: 'forward',  deletable: true },
  //   { id: 'cmd_2',  text: 'предыдущий слайд', action: 'backward', deletable: true },
  //   { id: 'cmd_3',  text: 'пауза презентации', action: 'forward',  deletable: true },
  //   { id: 'cmd_4',  text: 'продолжить показ',  action: 'forward',  deletable: true },
  //   { id: 'cmd_5',  text: 'начать сначала',    action: 'backward', deletable: true },
  //   { id: 'cmd_6',  text: 'остановить показ',  action: 'backward', deletable: false },
  //   { id: 'cmd_7',  text: 'увеличить масштаб', action: 'forward',  deletable: true },
  //   { id: 'cmd_8',  text: 'уменьшить масштаб', action: 'backward', deletable: true },
  //   { id: 'cmd_9',  text: 'открыть заметки',   action: 'forward',  deletable: false },
  //   { id: 'cmd_10', text: 'закрыть заметки',   action: 'backward', deletable: true },
  // ];
}

export async function createCommand({ text, action }) {
  return apiPost('/commands', { text, action });
}

export async function deleteCommand({ id, text }) {
  if (id) return apiDelete(`/commands/${encodeURIComponent(id)}`);
  return apiDelete('/commands', { text });
}

export async function uploadPresentation(file) {
  const fd = new FormData();
  fd.append('file', file);

  return apiUpload('/upload', fd);
}

export async function sendFeedback({ type, text }) {
  return apiPost('/feedback', {
    type,
    text,
  });
}

export async function deletePresentation(id) {
  return apiDelete(`/presentations/${encodeURIComponent(id)}`);
}

/**
 * Моковый API для тестирования обратной связи
 */
// export async function sendFeedback({ rating, text }) {
//   console.log('Отправка обратной связи:', { rating, text });

  // имитация задержки сервера
//   return new Promise((resolve) => {
//     setTimeout(() => resolve({ success: true }), 1000);
//   });
// }
